import { apiPost } from '~/_shared/utils/api/api.helpers';

// the mapId param is needed so we can count usage on presentational maps too
export const incrementRequestCount = (clientId: number, mapId: number, incrementBy: number): Promise<{ requests: number }> => {
  const requestUrl = `/api/clients/${clientId}/maps/${mapId}/directions-api/increment`;

  return apiPost(requestUrl, {
    increment: incrementBy,
  });
};
